export const FETCH_DESIGNERS_PREFIX = 'FETCH_DESIGNERS';
export const FETCH_DESIGNERS_REQUEST = `${FETCH_DESIGNERS_PREFIX}/REQUEST`;
export const FETCH_DESIGNERS_SUCCESS = `${FETCH_DESIGNERS_PREFIX}/SUCCESS`;
export const FETCH_DESIGNERS_FAILURE = `${FETCH_DESIGNERS_PREFIX}/FAILURE`;

export const DESIGNERS_CONTENT_PREFIX = `DESIGNERS_CONTENT`;
export const DESIGNERS_CONTENT_REQUEST = `${DESIGNERS_CONTENT_PREFIX}/REQUEST`;
export const DESIGNERS_CONTENT_SUCCESS = `${DESIGNERS_CONTENT_PREFIX}/SUCCESS`;
export const DESIGNERS_CONTENT_FAILURE = `${DESIGNERS_CONTENT_PREFIX}/FAILURE`;
